import { lazyLoad } from 'utils/loadable';

export const ApiKey = lazyLoad(
  () => import('./apiKey.page'),
  (module) => module.ApiKey
);
